import { Typography } from "antd";
import React from "react";
import Markdown from "react-markdown";

const { Title } = Typography;

type MarkdownContentProps = {
  content: string;
};

const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => (
  <Markdown
    components={{
      p({ children }) {
        return <Typography.Paragraph>{children}</Typography.Paragraph>;
      },
      h1({ children }) {
        return (
          <Title
            level={1}
            style={{ margin: "0" }}
          >
            {children}
          </Title>
        );
      },
      h2({ children }) {
        return (
          <Title
            level={2}
            style={{ margin: "0" }}
          >
            {children}
          </Title>
        );
      },
      h3({ children }) {
        return (
          <Title
            level={3}
            style={{ margin: "0" }}
          >
            {children}
          </Title>
        );
      },
      h4({ children }) {
        return (
          <Title
            level={4}
            style={{ margin: "0" }}
          >
            {children}
          </Title>
        );
      },
      h5({ children }) {
        return (
          <Title
            level={5}
            style={{ margin: "0" }}
          >
            {children}
          </Title>
        );
      },
    }}
  >
    {content}
  </Markdown>
);

export default MarkdownContent;
